import { getAttributeValue } from '~/helpers';
import { HTMLCustomElement } from '~/html-custom-element';

/**
 * Provides useful functions for select elements.
 *
 * @attribute default-value - The default selected value.
 */
export class SelectProvider extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.selector = this.querySelector('select');

    if (!this.selector) {
      console.error('The `select-provider` element must contain a select element.');
      return;
    }

    if (getAttributeValue(this, 'auto-size')) {
      this.on('change', this.selector, this.adjustSize.bind(this), null, true);
    }

    if (this.hasAttribute('default-value')) {
      [...this.selector.options].forEach((option, index) => {
        if (option.value === this.getAttribute('default-value')) {
          this.selector.selectedIndex = index;
        }
      });
    }
  }

  /**
   * Adjusts the size of the select element based on the selected option.
   */
  adjustSize() {
    const optionText = this.selector.options[this.selector.selectedIndex].text;
    const textElement = document.createElement('span');

    textElement.className = getAttributeValue(this, 'use-select-class', false)
      ? this.selector.className
      : this.className;
    textElement.textContent = optionText;
    textElement.style.visibility = 'hidden';
    textElement.style.alignSelf = 'start';
    textElement.style.width = 'auto';

    document.body.appendChild(textElement);

    /**
     * Apply the dynamic width.
     */
    this.selector.style.width = `${textElement.getBoundingClientRect().width}px`;

    /**
     * Clear up the test text element.
     */
    document.body.removeChild(textElement);

    this.selector.classList.add('size-adjusted');
  }
}
